import Radio from 'antd/lib/radio';
import * as React from 'react';
import { useState } from 'react';
import { RfqBidDetailsType } from '../../../SE.interfaces';
import SEFFBidCard from '../../../SEActions/SETasks/SEFFBidCard';
import RfqBidDetailsModal from './RfqBidDetailsModal';

interface RfqBidsProps {
  selectedBid: any;
  onBidSelection: (bid: any) => void;
  bidList: any;
  category: string;
  field: any;
  resetBids: () => void;
}

const RfqBids: React.FC<RfqBidsProps> = ({
  selectedBid, bidList, onBidSelection, field, resetBids
}) => {
  const [isBidDetailModalVisible, setIsBidDetailModalVisible] = useState<boolean>(false);
  const [bidDetailedData, setBidDetailedData] = useState<RfqBidDetailsType[]>();

  const renderSelectBid = () => {
    if (!bidList?.length) return (
      <div style={{ color: '#DF1D1D', fontSize: 12 }}>
        There is no bid available.
      </div>
    );

    return (
      <Radio.Group
        onChange={(e) => {
          onBidSelection(e.target.value);
        }}
        value={selectedBid}
      >
        {bidList?.map((item) => {
          return (
            <Radio style={{ display: 'flex', justifyContent: 'space-between' }} value={item}>
              <div>
                <SEFFBidCard
                  deviationFromL1={item.deviationFromL1}
                  searchResult={item}
                  extraContent={{
                    isServiceNamePresent: true,
                    isCutOffPresent: true,
                  }}
                  onViewDetails={() => handleViewDetails(item)}
                />
              </div>
            </Radio>
          );
        })}
      </Radio.Group>
    );
  };

  const renderSelectedBid = () => {
    return (
      <div>
        <SEFFBidCard
          deviationFromL1={selectedBid.deviationFromL1}
          searchResult={selectedBid}
          extraContent={{
            isServiceNamePresent: true,
            isCutOffPresent: true,
          }}
          onViewDetails={() => handleViewDetails(selectedBid)}
        />
      </div>
    );
  };

  const renderChangeSelection = () => {
    return (
      !field?.disabled &&
      selectedBid && (
        <div style={{
          display: 'flex',
          fontSize: '14px',
          lineHeight: '16px',
          color: '#1890FF',
          cursor: 'pointer',
          alignItems: 'flex-end',
          justifyContent: 'flex-start',
          marginTop: 16,
        }} onClick={() => {
          resetBids();
          }}>
          You want to change the Freight Forwarder?
        </div>
      )
    );
  };

  const handleViewDetails = (item) => {
    setBidDetailedData(item.bidDetailedData);
    setIsBidDetailModalVisible(true);
  };

  const renderBidDetailModal = () => {
    return (
      <RfqBidDetailsModal
        onClose={() => setIsBidDetailModalVisible(false)}
        visible={isBidDetailModalVisible}
        bidDetails={bidDetailedData}
      />
    );
  };

  const renderBidCards = () => {
    return (
      <>
        {selectedBid ? renderSelectedBid() : renderSelectBid()}
        {renderChangeSelection()}
        {isBidDetailModalVisible && renderBidDetailModal()}
      </>
    );
  };
  return renderBidCards();
}

export default RfqBids;
